import React, {useEffect, useState} from 'react';
import {Link, NavLink, useLocation, useParams} from 'react-router-dom';
import {
  DashboardLayout,
  PrimaryButton,
  SecondaryButton,
} from '../../../components';
import {Constants} from '../../../helpers';
import {CreditCheckContext} from '../../../helpers/context/CreditCheckContext';
import EditDecision from './UpdatedEditProcess/modals/EditDecision';
import Breadcrumbs from 'components/BreadCrumbs';
import {PAGES_URL} from 'helpers/constants';

const ROUTES = [
  {title: 'Overview', to: Constants.PAGES_URL.FLOWS_ANALYTICS},
  // {title: 'Events', to: Constants.PAGES_URL.FLOWS_EVENTS},
  {title: 'Cases', to: Constants.PAGES_URL.FLOWS_CASES},
  // {title: 'Accounts', to: Constants.PAGES_URL.FLOWS_ACCOUNTS},
  {title: 'Settings', to: Constants.PAGES_URL.FLOWS_SETTINGS},
];

function Routes({title, to, slug, name}) {
  const path = `${to.replace('/:slug', '')}/${slug}`;

  return (
    <NavLink
      to={{pathname: path}}
      state={{flowName: name}}
      className={({isActive}) =>
        `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
          isActive
            ? 'text-black bg-white shadow-tabs'
            : 'text-grey-500 bg-transparent'
        }`
      }
    >
      {title}
    </NavLink>
  );
}

function Layout({children}) {
  const {slug} = useParams();
  const {state} = useLocation();

  const {
    set: {setCurrentFlowData},
  } = React.useContext(CreditCheckContext);

  const [editDecisionOpen, setEditDecisionOpen] = useState(false);

  const flowName = state?.flowName || localStorage.getItem('flowName') || '';

  useEffect(() => {
    if (state?.flowData) {
      setCurrentFlowData(state?.flowData);
      localStorage.setItem('currentFlowData', JSON.stringify(state?.flowData));
    }
    if (state?.flowName) {
      localStorage.setItem('flowName', state?.flowName);
    }
  }, [setCurrentFlowData, state?.flowData, state?.flowName]);

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Fraud Flows</p>
      }
    >
      <div className="fixed w-[83.5%] top-[51px] ml-auto bg-white left-0 right-0 z-30 flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between px-8 border border-transparent border-b-[#E4E4E6]">
        <div className="flex items-center gap-3">
          <Breadcrumbs
            items={[
              {label: 'Fraud Flows', path: PAGES_URL.FLOWS},
              {label: flowName || ''},
            ]}
          />
        </div>

        <div className="flex items-center flex-wrap gap-3">
          <Link to={`/flows/edit-process/${slug}`}>
            <PrimaryButton
              buttonText="Manage Rules"
              xPadding="px-4"
              className="hidden sm:flex"
            />
          </Link>
          <SecondaryButton
            buttonText="Manage Decision"
            onClick={() => setEditDecisionOpen(!editDecisionOpen)}
          />
        </div>

        <EditDecision open={editDecisionOpen} setOpen={setEditDecisionOpen} />
      </div>

      <div className="py-3 mt-[103px]">
        <div className="rounded-md bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
          {ROUTES.map((route, index) => (
            <Routes key={index} name={flowName} {...route} slug={slug} />
          ))}
        </div>
      </div>
      {children}
    </DashboardLayout>
  );
}

export default Layout;
